import BaseApi from './BaseApi';
import { CAMPAIGNS_RESOURCE_NAME } from '../config/constants';

export default class CampaignApi extends BaseApi {
  static [`get${CAMPAIGNS_RESOURCE_NAME}`](params, cancelToken) {
    return this.get(`/campaign`, cancelToken);
  }

  static [`getOneOf${CAMPAIGNS_RESOURCE_NAME}`]({ id }, cancelToken) {
    return this.get(`/campaign/${id}`, cancelToken);
  }

  static [`getMsisdnsOf${CAMPAIGNS_RESOURCE_NAME}`]({ id }, cancelToken) {
    return this.get(`/campaign/msisdns/${id}`, cancelToken);
  }

  static [`download${CAMPAIGNS_RESOURCE_NAME}`]({ id, exportType }, cancelToken) {
    if (exportType === 'contacts') {
      return this.getFile(`/campaign/export/${id}`, cancelToken);
    } else if (exportType === 'mobileOperatorsReport') {
      return this.getFile(`/campaign/export-by-operators/${id}`, cancelToken);
    } else if (exportType === 'exportMsisdns') {
      return this.getFile(`/campaign/export-msisdns/${id}`, cancelToken);
    }

    return this.getFile(`/campaign/export/${id}`, cancelToken);
  }

  static [`deleteOneOf${CAMPAIGNS_RESOURCE_NAME}`]({ id }, cancelToken) {
    return this.delete(`/campaign/${id}`, cancelToken);
  }

  static [`delete${CAMPAIGNS_RESOURCE_NAME}`]({ ids }, cancelToken) {
    return this.delete(`/campaign?ids=${ids.join(',')}`, cancelToken);
  }

  static [`createDraft${CAMPAIGNS_RESOURCE_NAME}`](payload) {
    return this.post('/campaign', payload);
  }

  static [`createAndSend${CAMPAIGNS_RESOURCE_NAME}`](payload) {
    return this.post('/campaign/create-and-send', payload);
  }

  static [`send${CAMPAIGNS_RESOURCE_NAME}`]({ id }, cancelToken) {
    return this.post(`/campaign/send/${id}`, null, cancelToken);
  }

  static [`updateDraft${CAMPAIGNS_RESOURCE_NAME}`](payload) {
    return this.put('/campaign', payload);
  }
}
